import React from "react";
import type { CipherText } from "@b2bportal/purchase-api";
import { CartSelectors, useCheckoutSend } from "@hopper-b2b/checkout";
import { useCheckoutStateSelector as useSelector } from "@hopper-b2b/checkout";
import { PaymentScreenHandler } from "../../../../checkout";
import { PaymentEvent } from "../../../../checkout/states/payments";
import { type TEvent, Event } from "../../events";

export const PaymentLoader = () => {
  const send = useCheckoutSend<TEvent>();

  const priceQuoteCipherText = useSelector(
    CartSelectors.getPriceQuoteCipherText
  );

  const goToPrevStep = () => {
    send({
      type: Event.PREVIOUS,
    });
  };

  const goToNextStep = (
    paymentSessionToken: string,
    priceQuoteCipherText: CipherText
  ) => {
    // Update state with quote token received from uber payments
    send({
      type: PaymentEvent.SET_PAYMENT_DATA_AND_GO_NEXT,
      paymentSessionToken: paymentSessionToken,
      paymentQuoteToken: priceQuoteCipherText,
    });
  };

  const handleError = () => {
    return;
  };

  return priceQuoteCipherText ? (
    <PaymentScreenHandler
      goToPrevStep={goToPrevStep}
      goToNextStep={goToNextStep}
      handleError={handleError}
      priceQuoteCipherText={priceQuoteCipherText}
    />
  ) : null;
};
